// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ExFM","colMin":"styles_colMin__2vm3d"};